import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ISearchBoxProps, IPeoplePickerItemSelectedProps, PeoplePickerItem, ValidationState, NormalPeoplePicker, IPersonaProps, IPickerItemProps, TooltipHost, DialogFooter, CheckboxVisibility, ConstrainMode, StackItem } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch } from "../../../app/Hooks"
import { APIResponse, ApiMessage, SARAFA_API_URL, getFeedConnection, getHeaders, getSession } from "../../../app/SarafaAPI"
import { currencyFormatter, formatDate, printComponent, normalizeKey, timestampToDate, generateTradingViewSession, getTradingSessionTimestamp, roundTimestamp } from "../../../app/Helpers"
import { TableState } from "../../common/Table/TableSate"
import { useNavigate, useSearchParams } from "react-router-dom"
import { PageProps } from "../PageProps"
import {
    widget,
    ChartingLibraryWidgetOptions,
    LanguageCode,
    ResolutionString,
    ChartingLibraryFeatureset,
    IBasicDataFeed,
    CustomTimezoneId,
    TimezoneId,
} from '../../../charting_library';
import * as React from 'react';
import { getCurrentLanguage } from '../../../app/Helpers';
import { useAppSelector } from '../../../app/Hooks';
import { useParams } from 'react-router-dom';
import { getPage } from "../../../app/Pages"
import { GetCurrencyExchangeRatesReportRequest, GetCurrencyExchangeRatesReportResponse } from "../../../repository/Sarafa/report_pb"
import { GetCategoriesRequest, GetCurrencyPairsRequest, GetCurrencyPairsResponse } from "../../../repository/Sarafa/currency_pair_pb"
import { Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb"
import moment from "moment"
import { dismissMessage, getCategories, getItems, getReport, reset } from "./AdvancedChartPageSlice"
import { CurrencyForm } from "../../../app/Enums"
import { SessionExpiredDialog } from "../../common/SessionExpiredDialog/SessionExpiredDialog"
import { Message } from "../../common/Message/Message"
import { LocalStorageSaveLoadAdapter } from "../Storage"
import { HubConnectionState } from "@microsoft/signalr"

export interface ChartContainerProps {
    symbol: ChartingLibraryWidgetOptions['symbol'];
    interval: ChartingLibraryWidgetOptions['interval'];

    // BEWARE: no trailing slash is expected in feed URL
    datafeedUrl: string;
    libraryPath: ChartingLibraryWidgetOptions['library_path'];
    chartsStorageUrl: ChartingLibraryWidgetOptions['charts_storage_url'];
    chartsStorageApiVersion: ChartingLibraryWidgetOptions['charts_storage_api_version'];
    clientId: ChartingLibraryWidgetOptions['client_id'];
    userId: ChartingLibraryWidgetOptions['user_id'];
    fullscreen: ChartingLibraryWidgetOptions['fullscreen'];
    autosize: ChartingLibraryWidgetOptions['autosize'];
    studiesOverrides: ChartingLibraryWidgetOptions['studies_overrides'];
    container: ChartingLibraryWidgetOptions['container'];
}
let org: number = -1;

var lastTime: any = undefined;
var currentReselution: any = undefined;
var myInterval: any = undefined;

let req: GetCurrencyExchangeRatesReportRequest;
let reqPair: GetCurrencyPairsRequest;
let reqCategories: GetCategoriesRequest;

let getItemsPromise: any;
let getFilterPromise: any;
let actionPromise: any;
var lastBar: any = undefined;

const key = "trading/chart"
export const AdvancedChartPage: React.FunctionComponent<PageProps> = (props) => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const chartContainerRef = useRef<HTMLDivElement>(null)
    const isMobile = searchParams.get('isMobile');
    const isMobileBrowser = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const disabled_features: ChartingLibraryFeatureset[] = []
    const disabled_features_mobile: ChartingLibraryFeatureset[] = [
        'left_toolbar', "header_widget", 'timeframes_toolbar', 'edit_buttons_in_legend', 'context_menus', 'control_bar', 'border_around_the_chart',
    ]


    const [isDraw, setIsDraw] = useState(false);

    const state: {
        isChangeStateLoading: boolean,
        set: TableState,
        report: TableState,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        searchText: string | undefined,
        filters: any[],
        categories: TableState,


    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.advancedChartPage.isChangeStateLoading,
            set: state.advancedChartPage.set,
            message: state.advancedChartPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            searchText: state.advancedChartPage.searchText,
            filters: state.advancedChartPage.filters,
            report: state.advancedChartPage.report,
            categories: state.advancedChartPage.categories,


        }
    })

    const [orgName, setOrgName] = useState("");//getSession
    const [isIframe, setIsIframe] = useState(false);

    const defaultProps: Omit<ChartContainerProps, 'container'> = {
        symbol: 'USDLYD',
        interval: '30' as ResolutionString,
        datafeedUrl: 'https://localhost:7166/api/trading-view/udf',
        libraryPath: '/charting_library/',
        chartsStorageUrl: 'https://saveload.tradingview.com',
        chartsStorageApiVersion: '1.1',
        clientId: 'tradingview.com',
        userId: 'public_user_id',
        fullscreen: false,
        autosize: true,
        studiesOverrides: {},
    };



    const DataFeed: IBasicDataFeed = {

        onReady: (callback: any) => {
            setTimeout(() => callback({
                // Represents the resolutions for bars supported by your datafeed
                supported_resolutions: ["1S", "1", "15", "30", "60", "240", "1D", "1W", "1M"],

                supports_search: true,
                supports_group_request: false,
                supports_marks: true,
                supports_timescale_marks: true,
                supports_time: true,

            }));
        },

        searchSymbols: async (
            userInput: any,
            exchange: any,
            symbolType: any,
            onResultReadyCallback: any,
        ) => {
            if (state.categories.items.length == 0)
                await dispatch(getCategories({ body: reqCategories, headers: getHeaders() }))



            let resulte: any[] = [];
            if (state.set.items.length > 0) {
                state.set.items.forEach(e => {
                    resulte.push({
                        symbol: (e.baseCurrencyCode + "" + e.quoteCurrencyCode),
                        full_name: orgName + ":" + (e.baseCurrencyCode + "" + e.quoteCurrencyCode), // e.g. BTCE:BTCUSD
                        description: e?.name,
                        exchange: getCurrentLanguage() == "ar" ? state.categories.items.filter(ex => ex.id == e.categoryId)?.at(0)?.parentCategoryNameAr ?? "" : state.categories.items.filter(ex => ex.id == e.categoryId)?.at(0)?.parentCategoryNameEn ?? '',

                        ticker: e.id,
                        logo_urls: ["" + e.logoURL],
                        type: e.categoryId ? getCurrentLanguage() == "ar" ? e.categoryNameAr : e.categoryNameEn : e.baseCurrencyForm == CurrencyForm.FIAT ? t("fiatForm") : e.baseCurrencyForm == CurrencyForm.COMMODITY ? t("commodityForm") : e.baseCurrencyForm == CurrencyForm.CRYPTO ?
                            t("cryptoForm") : e.baseCurrencyForm == CurrencyForm.DIGITAL ? t("digitalForm") : e.baseCurrencyForm == CurrencyForm.REPRESENTATIVE ? t("representativeForm") : ""



                    });

                })
            }
            setTimeout(() => { onResultReadyCallback(resulte); }, 0);

        },

        resolveSymbol: async (
            symbolName: any,
            onSymbolResolvedCallback: any,
            onResolveErrorCallback: any,
            extension: any
        ) => {

            if (state.set.items.length > 0) {
                const index = state.set.items.findIndex((element) => (element.id == symbolName));
                if (index >= 0) {
                    const found = state.set.items[index]
                    const symbolInfo = {
                        ticker: index + ":" + (found.baseCurrencyCode + "" + found.quoteCurrencyCode),
                        original_unit_id: symbolName,
                        name: (found.baseCurrencyCode + "" + found.quoteCurrencyCode),
                        description: found.name,
                        type: found.categoryId ? getCurrentLanguage() == "ar" ? found.categoryNameAr : found.categoryNameEn : found.baseCurrencyForm == CurrencyForm.FIAT ? t("fiatForm") : found.baseCurrencyForm == CurrencyForm.COMMODITY ? t("commodityForm") : found.baseCurrencyForm == CurrencyForm.CRYPTO ?
                            t("cryptoForm") : found.baseCurrencyForm == CurrencyForm.DIGITAL ? t("digitalForm") : found.baseCurrencyForm == CurrencyForm.REPRESENTATIVE ? t("representativeForm") : "",
                        timezone: "LocalTimeZone" as TimezoneId,

                        session: generateTradingViewSession(found.tradingDays, found.tradingHours, found.openingDay),
                        exchange: getCurrentLanguage() == "ar" ? state.categories.items.filter(ex => ex.id == found.categoryId)?.at(0)?.parentCategoryNameAr ?? "" : state.categories.items.filter(ex => ex.id == found.categoryId)?.at(0)?.parentCategoryNameEn ?? '',

                        minmov: 1,
                        pricescale: Number("1".padEnd(found.quoteCurrencyDecimalPlaces + 1, '0')),
                        has_intraday: true,
                        has_daily: true,
                        has_weekly_and_monthly: true,

                        visible_plots_set: 'ohlcv',
                        supported_resolutions: ["1S", "1", "15", "30", "60", "240", "1D", "1W", "1M"],
                        volume_precision: found.baseCurrencyDecimalPlaces,
                        data_status: found.isMarketOpen ? 'streaming' : 'endofday',
                        delay: found.isMarketOpen ? 0 : -1,
                        logo_urls: ["" + found.logoURL]
                    };
                    setTimeout(() => { onSymbolResolvedCallback(symbolInfo); }, 0);

                } else {
                    setTimeout(() => { onResolveErrorCallback(); }, 0);

                }
            } else {
                setTimeout(() => { onResolveErrorCallback(); }, 0);

            }





        },

        getBars: async (symbolInfo: any, resolution: any, periodParams: any, onHistoryCallback: any, onErrorCallback: any) => {

            try {

                let from = new Date(periodParams.from * 1000);
                let to = new Date(periodParams.to * 1000);

                const wrapper = new Timestamp();
                wrapper.fromDate(from)
                req.setFrom(wrapper)

                const wrapper2 = new Timestamp();
                wrapper2.fromDate(to)
                req.setTo(wrapper2)

                var groupby = -1;
                if (resolution == "60") {
                    groupby = 3;
                }
                else if (resolution == "1D") {
                    groupby = 0;

                }
                else if (resolution == "1M") {
                    groupby = 1;

                }
                else if (resolution == "12M") {
                    groupby = 2;

                }
                else if (resolution == "1") {
                    groupby = 4;
                } else if (resolution == "15") {
                    groupby = 15;
                } else if (resolution == "30") {
                    groupby = 30;
                } else if (resolution == "240") {
                    groupby = 240;
                } else if (resolution == "1W") {
                    groupby = 10080;
                }
                if (groupby != -1) {
                    const wrap = new Int32Value();
                    wrap.setValue(groupby)
                    req.setGroupby(wrap)
                } else {
                    req.setGroupby(undefined)
                }


                if (symbolInfo.original_unit_id) {
                    req.setCurrencypair(symbolInfo.original_unit_id);
                } else {
                    onHistoryCallback([], {
                        noData: true,
                    });
                    return;
                }
                req.setCurrencypair(symbolInfo.original_unit_id);

                var request = await dispatch(getReport({ body: req, headers: getHeaders() }))
                const payload = request.payload as APIResponse<GetCurrencyExchangeRatesReportResponse.AsObject>;

                var bars = (payload?.response?.success?.reportList.map(val => {

                    let r = {

                        open: Number(val.opentradingprice?.value ?? 0).valueOf(),
                        high: Number(val.highesttradingprice?.value ?? 0).valueOf(),
                        low: Number(val.lowsettradingprice?.value ?? 0).valueOf(),
                        close: Number(val.closetradingprice?.value ?? 0).valueOf(),
                        time: (timestampToDate(val.date?.seconds, val.date?.nanos, groupby >= 3 && groupby <= 240))?.getTime(),
                        volume: Number(val.volumebase?.value ?? 0).valueOf(),

                    }

                    return r;


                }
                ) as any[])

                if (periodParams.firstDataRequest) {
                    lastTime = undefined
                    lastBar = undefined
                }
                if (bars == undefined || bars.length == 0) {

                    if (periodParams.firstDataRequest) {
                        var yesterday = new Date();
                        var nextTime = moment(yesterday).startOf('day').toDate().getTime() - 1000 * 60 * 60 * 24 * 1;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
                        onHistoryCallback([], {
                            noData: true,
                            nextTime: nextTime
                        });
                    } else {
                        var nextTime = moment(lastTime).startOf('day').toDate().getTime() - 1000 * 60 * 60 * 24 * 1;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
                        onHistoryCallback([], {
                            noData: true,
                            nextTime: nextTime
                        });
                    }

                } else {
                    if (lastTime == undefined) {
                        lastTime = bars[bars.length - 1].time;
                        lastBar = bars[bars.length - 1];

                    } else {
                        if (lastTime < bars[bars.length - 1].time) {
                            lastTime = bars[bars.length - 1].time;
                            lastBar = bars[bars.length - 1];
                        }
                    }
                    onHistoryCallback(bars, {
                        noData: false,
                    });
                }


            } catch (err) {

                //let message = toApiMessage((err as RpcError).metadata);
                onErrorCallback(err);

            }

        },


        async subscribeBars(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback) {
            if (myInterval != undefined) {
                clearInterval(myInterval);
            }
            var connection = await getFeedConnection()
            if (connection != null) {
                connection.off("PRICE_" + symbolInfo.original_unit_id + ""); // clean old
                connection.on("PRICE_" + symbolInfo.original_unit_id + "", (message: any) => {
                    try {
                        var val = JSON.parse(message)
                        //{"isTrade":1,"currencyPair":"6840b902c13dcaa9977c9dc5","TradingPrice":7.245,"SellPrice":7.11,"BuyPrice":7.22,"VolumeBase":0.0,"VolumeQuote":0.0,"CreatedDate":"2025-07-27T19:28:55.8737168Z"}
                        var l = getTradingSessionTimestamp(new Date(val.CreatedDate), resolution, symbolInfo.session);
                        if (["1D", "1W", "1M", "12M"].includes(resolution)) {
                            // Resets to 00:00:00 of that day
                            l = moment(l).set({
                                hour: moment(lastTime).hour(),
                                minute: moment(lastTime).minute(),
                                second: moment(lastTime).second(),
                                millisecond: moment(lastTime).millisecond()
                            }).valueOf();
                        }
                        else if (["60", "240", "1H", "4H"].includes(resolution)) {
                            // Resets to XX:00:00 (Top of the hour)
                            l = moment(l).set({
                                minute: moment(lastTime).minute(),
                                second: moment(lastTime).second(),
                                millisecond: moment(lastTime).millisecond()
                            }).valueOf();

                        }
                        else {
                            // Resets to XX:XX:00 (Start of the minute)
                            l = moment(l).set({
                                second: moment(lastTime).second(),
                                millisecond: moment(lastTime).millisecond()
                            }).valueOf();
                        }

                        if (lastTime > l) {
                            return;
                        }
                        var bar = null;
                        if (lastTime != l) {
                            bar = {
                                open: Number(val.TradingPrice).valueOf(),
                                high: Number(val.TradingPrice).valueOf(),
                                low: Number(val.TradingPrice).valueOf(),
                                close: Number(val.TradingPrice).valueOf(),
                                time: l,
                                volume: Number(val.VolumeBase).valueOf(),

                            }
                        } else {
                            bar = {
                                open: lastBar.open,
                                high: Math.max(lastBar.high, val.TradingPrice),
                                low: Math.min(lastBar.low, val.TradingPrice),
                                close: val.TradingPrice,
                                time: l
                            };
                        }
                        lastBar = bar;
                        lastTime = bar.time;
                        onTick(bar);
                    } catch {

                    }

                });
            }
            myInterval = setInterval(async () => {
                try {
                    /* (connection == null ||
                  connection.state !== HubConnectionState.Connected) */
                    if (lastTime) {

                        let from = new Date(lastTime + 1);
                        const wrapper = new Timestamp();
                        wrapper.fromDate(from)
                        req.setFrom(wrapper)


                        let to = new Date();
                        const wrapper2 = new Timestamp();
                        wrapper2.fromDate(to)
                        req.setTo(wrapper2)
                        req.setGroupby(undefined)



                        var groupby = -1;
                        if (resolution == "60") {
                            groupby = 3;
                        }
                        else if (resolution == "1D") {
                            groupby = 0;

                        }
                        else if (resolution == "1M") {
                            groupby = 1;

                        }
                        else if (resolution == "12M") {
                            groupby = 2;

                        }
                        else if (resolution == "1") {
                            groupby = 4;
                        } else if (resolution == "15") {
                            groupby = 15;
                        } else if (resolution == "30") {
                            groupby = 30;
                        } else if (resolution == "240") {
                            groupby = 240;
                        } else if (resolution == "1W") {
                            groupby = 10080;
                        }
                        if (groupby != -1) {
                            const wrap = new Int32Value();
                            wrap.setValue(groupby)
                            req.setGroupby(wrap)
                        } else {
                            req.setGroupby(undefined)
                        }

                        if (symbolInfo.original_unit_id) {
                            req.setCurrencypair(symbolInfo.original_unit_id);
                        } else {
                            return;
                        }

                        req.setCurrencypair(symbolInfo.original_unit_id);

                        var request = await dispatch(getReport({ body: req, headers: getHeaders() }))
                        const payload = request.payload as GetCurrencyExchangeRatesReportResponse.AsObject;

                        var bars = (payload?.success?.reportList.map(val => {


                            let r = {

                                open: Number(val.opentradingprice?.value ?? 0).valueOf(),
                                high: Number(val.highesttradingprice?.value ?? 0).valueOf(),
                                low: Number(val.lowsettradingprice?.value ?? 0).valueOf(),
                                close: Number(val.closetradingprice?.value ?? 0).valueOf(),
                                time: (timestampToDate(val.date?.seconds, val.date?.nanos, groupby >= 3 && groupby <= 240))?.getTime(),
                                volume: Number(val.volumebase?.value ?? 0).valueOf(),

                            }
                            //console.log(r)
                            return r;
                        }
                        ) as any[])

                        if (bars.length != 0) {
                            if (lastTime < bars[bars.length - 1].time) {
                                lastTime = bars[bars.length - 1].time;
                                lastBar = bars[bars.length - 1];

                            }
                            if (lastTime > lastBar.time) {
                                return;
                            }
                            onTick(bars[bars.length - 1]);
                        } else {
                        }
                        // onTick(bars[bars.length - 1]);
                    }
                } catch (err) {

                    //throw err
                    //let message = toApiMessage((err as RpcError).metadata);


                }


            }, 60 * 1000);

        },
        unsubscribeBars(listenerGuid) {
            //clearInterval(myInterval);

        },
    };

    const widgetOptions: ChartingLibraryWidgetOptions = {

        // BEWARE: no trailing slash is expected in feed URL
        // tslint:disable-next-line:no-any
        //datafeed: new (window as any).Datafeeds.UDFCompatibleDatafeed(defaultProps.datafeedUrl),
        datafeed: DataFeed,
        interval: defaultProps.interval as ChartingLibraryWidgetOptions['interval'],
        container: chartContainerRef.current as HTMLElement,
        library_path: defaultProps.libraryPath as string,
        locale: getCurrentLanguage() as LanguageCode,
        charts_storage_url: defaultProps.chartsStorageUrl,
        charts_storage_api_version: defaultProps.chartsStorageApiVersion,
        client_id: defaultProps.clientId,
        user_id: defaultProps.userId,
        fullscreen: defaultProps.fullscreen,
        autosize: defaultProps.autosize,
        studies_overrides: defaultProps.studiesOverrides,
        enabled_features: isMobile ? [] : ["study_templates", "move_logo_to_main_pane", "show_symbol_logos", "show_symbol_logo_in_legend",
            "show_zoom_and_move_buttons_on_touch", "show_exchange_logos", "saveload_separate_drawings_storage", "disable_resolution_rebuild"] as ChartingLibraryFeatureset[],
        disabled_features: isMobile && isDraw ? disabled_features : isMobile ? disabled_features_mobile : disabled_features,
        theme: state?.isDarkModeEnabled ? "dark" : 'light',
        debug: false,
        save_load_adapter: new LocalStorageSaveLoadAdapter(),
        timezone: "LocalTimeZone" as TimezoneId,
        custom_timezones: [
            {
                id: 'LocalTimeZone' as CustomTimezoneId,
                title: 'Local Time Zone',
                alias: `Etc/GMT${(new Date().getTimezoneOffset() / -60) >= 0 ? '-' : '+'}${Math.abs(new Date().getTimezoneOffset() / -60)}`
            },
        ],


    };


    useEffect(() => {
        req = new GetCurrencyExchangeRatesReportRequest();
        reqPair = new GetCurrencyPairsRequest();
        reqCategories = new GetCategoriesRequest();
        reqCategories.setNumofresults(1000)
        dispatch(getCategories({ body: reqCategories, headers: getHeaders() }))

        const isIframe = searchParams.get('isIframe');

        if (isIframe != undefined) {
            setIsIframe(isIframe == "1")
        }
        const isDraw = searchParams.get('isDraw');
        if (isDraw != undefined) {
            setIsDraw(isDraw == "1")
        }

        reqPair.setNextto(undefined)
        reqPair.setNumofresults(1000)
        reqPair.setOrder(true)

        getItemsPromise = dispatch(getItems({ body: reqPair, headers: getHeaders() }))


        return () => {
            // tvWidget.remove();
            getItemsPromise?.abort();
            getFilterPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
            //  clearInterval(myInterval);

        };
    }, []);



    useEffect(() => {
        if (state.set.items?.length > 0) {
            let item = state.set.items[0];
            setOrgName(getSession()?.organization?.name?.value ?? "")
            if (item) {
                var symbol = searchParams.get('symbol');
                widgetOptions.symbol = symbol ?? item.id
                initWedgit();

            }
        }
    }, [state.set.items])
    const initWedgit = () => {

        const tvWidget = new widget(widgetOptions);
        tvWidget?.chartReady().then(() => {
            tvWidget.activeChart().setChartType(2);
            tvWidget.changeTheme(state?.isDarkModeEnabled ? "dark" : 'light');
        });

    }
    return isMobileBrowser == true && isIframe == true && chartContainerRef != null ? <div
        ref={chartContainerRef}
        className={'TVChartContainer'}
        style={{ height: '100%' }}
    /> : isMobileBrowser == true ? <div
        ref={chartContainerRef}
        className={'TVChartContainer'}
        style={{ height: 'calc(100vh - 90px)' }}
    /> : <div
        ref={chartContainerRef}
        className={'TVChartContainer'}
        style={{ height: '100%' }}
    />
}




